import customStylesSchemaEnhancer from './customStylesSchemaEnhancer';
import withCustomStyles from './withCustomStyles';
import BlockToolbarView from './components//BlockToolbar/View';
import BlockToolbarEdit from './components//BlockToolbar/Edit';
import linkIconSVG from '@plone/volto/icons/link.svg';
import EventView from './customizations/components/theme/View/EventView';
import IG3ISRecognition from './components/IG3ISRecognition/View';
import CamsNcpView from './components/CamsNcp/View';

const applyConfig = (config) => {
  config.settings = {
    ...config.settings,
    isMultilingual: false,
    supportedLanguages: ['en'],
    defaultLanguage: 'en',
    maxFileUploadSize: 5368709120, // 5GB in bytes
  };

  config.views.contentTypesViews = {
    ...config.views.contentTypesViews,
    Event: EventView, // Sobrescribe la vista para los eventos
  };

  config.views.layoutViews = {
    ...config.views.layoutViews,
    cams_ncp_view: CamsNcpView, // Vista de página completa para CAMS NCP
  };

  config.blocks.blocksConfig.BlockToolbar = {
    id: 'BlockToolbar',
    title: 'Blo',
    group: 'common',
    icon: linkIconSVG,
    view: BlockToolbarView,
    edit: BlockToolbarEdit,
    restricted: false,
    mostUsed: true,
    sidebarTab: 1,
  };

  config.blocks.blocksConfig.IG3ISRecognition = {
    id: 'IG3ISRecognition',
    title: 'IG3IS Recognition',
    group: 'common',
    icon: linkIconSVG,
    view: IG3ISRecognition,
    restricted: false,
    mostUsed: false,
    sidebarTab: 1,
  };

  return config;
};

export default applyConfig;
